export const jobSuggestionsActionTypes = {
    'PAGE_INIT': 'JOB_SUGGESTIONS_PAGE_INIT',
    'PAGE_NEXT': 'JOB_SUGGESTIONS_PAGE_NEXT',
    'PAGE_PREVIOUS': 'JOB_SUGGESTIONS_PAGE_PREVIOUS',
    'PAGE_REQUEST': 'JOB_SUGGESTIONS_PAGE_REQUEST',
    'PAGE_SUCCESS': 'JOB_SUGGESTIONS_PAGE_SUCCESS',
    'PAGE_ERROR': 'JOB_SUGGESTIONS_PAGE_ERROR',
    'TOGGLE_SELECTION': 'JOB_SUGGESTIONS_TOGGLE_SELECTION',
    'CLEAR_SELECTION': 'JOB_SUGGESTIONS_CLEAR_SELECTION',
    'TOGGLE_ALL': 'JOB_SUGGESTIONS_TOGGLE_ALL',
    'ADD_FILTER': 'JOB_SUGGESTIONS_ADD_FILTER',
    'REMOVE_FILTER': 'JOB_SUGGESTIONS_REMOVE_FILTER',
};
